export default __webpack_public_path__ + "static/media/aury.14157a56.svg";